<template>
  <div class="edit-detailed-table">
    <!-- 搜索查询部分 -->
    <a-form
      class="search-form clearfix"
    >
      <a-form-item
        label="邮箱："
        class="email-input"
      >
        <a-input
          v-model="searchData.email"
          placeholder="请输入"
          @change="onChangeInput($event, 'email')"
        />
      </a-form-item>
      <a-form-item
        label="联系人："
        class="contact-input"
      >
        <a-input
          v-model="searchData.name"
          placeholder="请输入"
          @change="onChangeInput($event, 'name')"
        />
      </a-form-item>
      <a-form-item
        label="添加时间："
        class="addtime-input"
      >
        <a-range-picker
          :value="addtime"
          format="YYYY-MM-DD"
          @change="onChangeRange"
        />
      </a-form-item>
      <a-form-item
        label="状态："
        class="status-input"
      >
        <a-select
          v-model="searchData.status"
          on-change="onChangeState"
        >
          <a-select-option value="">
            全部
          </a-select-option>
          <a-select-option :value="1">
            正常
          </a-select-option>
          <a-select-option :value="2">
            退订
          </a-select-option>
        </a-select>
      </a-form-item>
      <div class="btns fr">
        <a-button
          type="primary"
          @click="onSearch"
        >
          查询
        </a-button>
        <a-button @click="onReset">
          重置
        </a-button>
      </div>
    </a-form>
    <!-- 添加/清空联系人 -->
    <div
      class="operate-box clearfix"
    >
      <a-dropdown
        v-if="!selectedRowKeys.length"
        class="fl"
        :trigger="['click', 'hover']"
      >
        <a-button
          type="primary"
          class="ant-dropdown-link more-btn"
          @click="e => e.preventDefault()"
        >
          添加联系人 <i class="iconfont iconicon-test19" />
        </a-button>
        <a-menu slot="overlay">
          <a-menu-item @click="filterContact">
            <a>筛选添加</a>
          </a-menu-item>
          <a-menu-item @click="addContact">
            <a>手动添加</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      <div
        v-if="selectedRowKeys.length"
        class="fl result"
      >
        <span>已选择 <i class="fs-blue">{{ selectedRowKeys.length }}</i> 人</span>
        <a-button
          class="del-selected-btn"
          @click="handleDeleteSeleted"
        >
          删除选中
        </a-button>
      </div>
      <a-button
        v-if="listDatas && listDatas.length && !selectedRowKeys.length"
        class="fl clear-contact-btn"
        @click="clearSelectedContact"
      >
        清空联系人
      </a-button>
    </div>
    <!-- 表格 -->
    <a-table
      row-key="id"
      :columns="columns"
      :data-source="listDatas"
      :row-selection="listDatas && listDatas.length ? { selectedRowKeys: selectedRowKeys, onChange: onSelectChange } : null"
      :pagination="false"
      :locale="{
        'emptyText': '暂无数据'
      }"
      :loading="loading"
    >
      <template
        slot="name"
        slot-scope="text"
      >
        {{ text || '--' }}
      </template>
      <template
        slot="status"
        slot-scope="text"
      >
        {{ setStatusName(text) }}
      </template>
    </a-table>
    <pagination
      v-if="listDatas && listDatas.length"
      ref="pagination"
      :pagination="pagination"
      @change="handlePage"
    />
    <add-contact-modal
      :visible.sync="showAddContactModal"
      :contactid="contactid"
      :has-name="false"
      @result="selecteContactResult"
    />
    <importContactFailModal
      :visible.sync="showImportContactFailModal"
    />
    <filter-contact-modal
      :visible.sync="showFilterContactModal"
      :contactid="contactid"
      @handleConfigModal="handleConfigModal"
    />
    <filter-config-modal :visible.sync="showFilterConfigModal" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Pagination from '@/components/pc/Pagination'
import AddContactModal from './AddContactModal'
import importContactFailModal from './ImportContactFailModal'
import FilterContactModal from './FilterContactModal'
import FilterConfigModal from './FilterConfigModal'

export default {
  components: {
    Pagination,
    AddContactModal,
    importContactFailModal,
    FilterContactModal,
    FilterConfigModal
  },
  props: {
    contactid: {
      type: [String, Number],
      default: ''
    },
    getContactName: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      addtime: [],
      searchData: {
        email: '',
        name: '',
        starttime: '',
        endtime: '',
        status: ''
      },
      selectedRowKeys: [],
      showAddContactModal: false,
      // showImportContactFailMessage: false,
      showImportContactFailModal: false,
      showFilterContactModal: false,
      showFilterConfigModal: false
    }
  },
  computed: {
    ...mapState('edm/editContactList', ['loading', 'columns', 'listDatas', 'pagination', 'contactName', 'importContactResult']),

    currentPage () {
      const { page = 1 } = this.$route.query
      return parseInt(page)
    },
    pageSize () {
      const { limit = 10 } = this.$route.query
      return parseInt(limit)
    }
  },
  watch: {
    $route (to, from) {
      this.pagination.currentPage = this.currentPage
      this.pagination.pageSize = this.pageSize
      this.getList()
    }
  },

  created () {
    this.pagination.currentPage = this.currentPage
    this.pagination.pageSize = this.pageSize
    this.getList()
  },
  methods: {
    ...mapActions('edm/editContactList', ['fetchContactlist', 'delContactList']),

    onChangeInput (e, name) {
      let val = e.target.value
      this.searchData[name] = val
    },
    onChangeRange (date, dateStr) {
      this.addtime = date
      this.searchData.starttime = dateStr[0]
      this.searchData.endtime = dateStr[1]
    },
    onChangeState (val) {
      this.searchData.status = val
    },
    onSearch () {
      this.pagination.currentPage = 1
      this.pagination.pageSize = 10
      this.getList()
    },
    onReset () {
      this.addtime = []
      this.searchData = {
        email: '',
        name: '',
        starttime: '',
        endtime: '',
        status: ''
      }
      this.pagination.currentPage = 1
      this.pagination.pageSize = 10
      this.getList()
    },
    async getList () {
      let params = {}
      params.page = this.pagination.currentPage
      params.limit = this.pagination.pageSize
      params.contactid = this.contactid || ''
      params = Object.assign(params, this.searchData)

      let chain = await this.fetchContactlist(params)
      chain.onSuccess(res => {
        this.getContactName(this.contactName)
      })
    },

    onSelectChange (selectedRowKeys) {
      // console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    handlePage (pagination) {
      // this.pagination.currentPage = pagination.currentPage
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagination.currentPage,
          limit: pagination.pageSize,
          ...this.tableSort,
          _t: new Date().getTime()
        }
      })
    },
    setStatusName (text) {
      let name = ''
      switch (text) {
        case 1:
          name = '正常'
          break
        case 2:
          name = '退订'
          break
      }
      return name
    },
    addContact () {
      this.showAddContactModal = true
    },
    filterContact () {
      this.showFilterContactModal = true
    },
    handleDeleteSeleted () {
      this.$confirm({
        title: '删除选中联系人',
        content: <div>删除后<i class="fs-orange">不可恢复，</i>确定删除？</div>,
        closable: true,
        okText: '确定',
        okType: 'primary',
        cancelText: '取消',
        class: 'confirm-warn-modal',
        onOk: async () => {
          let chain = await this.delContactList({
            id: this.selectedRowKeys,
            contactid: this.contactid
          })
          chain.onSuccess(res => {
            this.selectedRowKeys = []
            this.$router.push({
              name: 'EditContactList',
              params: {
                contactid: this.contactid
              },
              query: {
                _t: new Date().getTime()
              }
            })
          })
        }
      })
    },
    clearSelectedContact () {
      this.$confirm({
        title: '清空联系人',
        content: <div>清空联系人将导致当前清单的<i class="fs-orange">所有联系人被删除，且不可恢复，</i>确定清空？</div>,
        closable: true,
        okText: '确定',
        okType: 'primary',
        cancelText: '取消',
        class: 'confirm-warn-modal',
        onOk: async () => {
          let chain = await this.delContactList({
            contactid: this.contactid
          })
          chain.onSuccess(res => {
            this.$router.push({
              name: 'EditContactList',
              params: {
                contactid: this.contactid
              },
              query: {
                _t: new Date().getTime()
              }
            })
          })
        }
      })
    },
    selecteContactResult (res = []) {
      // this.selectedRowKeys = res.map(item => item.id)
      if (res.length) {
        // this.showImportContactFailMessage = true
        this.showImportContactFailModal = true
      }

      this.$router.push({
        name: 'EditContactList',
        params: {
          contactid: this.contactid
        },
        query: {
          _t: new Date().getTime()
        }
      })
    },
    handleLookFail () {
      /* let { failArr } = this.importContactResult
      let content = <div>
        {
          newArr.map(item => {
            return <p>{ item }</p>
          })
        }
      </div>
      this.$confirm({
        title: '添加失败的邮箱地址',
        content,
        closable: true,
        footer: null,
        class: 'importContactFailModal'
      }) */
      this.showImportContactFailModal = true
    },
    handleConfigModal (visible) {
      this.showFilterConfigModal = visible
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .ant-checkbox-wrapper {
  margin: 0;
}
.ant-form-item {
  display: inline-block;
  margin-right: 14px;
}
::v-deep .ant-form-item-label {
  vertical-align: inherit;
}
::v-deep .ant-form-item-control-wrapper {
  display: inline-block;
}
.email-input ::v-deep .ant-form-item-control-wrapper .ant-input {
  width: 160px;
}
.contact-input ::v-deep .ant-form-item-control-wrapper .ant-input {
  width: 120px;
}
.addtime-input ::v-deep .ant-form-item-control-wrapper .ant-input {
  width: 240px;
}
.status-input ::v-deep .ant-form-item-control-wrapper .ant-select {
  width: 120px;
}
.search-form {
  width: 1042px;
  .ant-btn {
    margin-bottom: 24px;
  }
}
.ant-table-wrapper {
  min-width: 1042px;
}
.ant-btn-default {
  margin-right: 0;
}
.operate-box {
  margin-bottom: 24px;
}
.ant-dropdown-link {
  color: #fff;
}
.del-selected-btn {
  margin-left: 16px;
}
.clear-contact-btn {
  line-height: 32px;
}
i {
  font-style: normal;
}
</style>
